export const onLogin = (token, groups) => {
  return (dispatch) => {
    dispatch({
      type: SESSION_ACTIONS.SET_TOKEN,
      payload: {
        token,
        groups: groups,
      },
    });
  };
};
export const onLogout = () => {
  return {
    type: SESSION_ACTIONS.CLEAR_TOKEN,
    payload: null,
  };
};

export const SESSION_ACTIONS = {
  SET_TOKEN: "SET_TOKEN",
  CLEAR_TOKEN: "CLEAR_TOKEN",
};
